<div class="container rtl">
    <div class="row justify-content-between">
        <div class="col-lg-5 d-flex align-items-center justify-content-center about-img">
            <img src="assets/img/about-img.svg" class="img-fluid" alt="" data-aos="zoom-in">
        </div>
        <div class="col-lg-6 pt-5 pt-lg-0 iran-sans">
            <h3 data-aos="fade-up">کاربردهای دکتر می</h3>
            <div class="my-row w-100 pb-2"></div>
            <p data-aos="fade-up" data-aos-delay="100">
                دسترسی آسان به خدمات آنلاین سلامت، ماموریت اصلی ماست. همه مردم و پزشکان می توانند به راحتی از کاربردهای متنوع آن بهره ببرند.
            </p>
            <div class="row">
                <div class="col-md-6" data-aos="fade-up" data-aos-delay="100">
                    <i class="bx bx-face"></i>
                    <h4>عموم مردم</h4>
                    <p>
                        کلیه افراد جامعه می‌توانند با استفاده از دکترمی، خدمات آنلاین سلامت مانند نوبت‌دهی، مشاوره و
                        ویزیت آنلاین را دریافت نمایند. دسترسی به خدمات و اطلاعات سلامت خود داشته باشند. همچنین از
                        جدیدترین و معتبرترین اطلاعات پزشکی و روش‌های پیشگیری و درمانی مطلع شوند و از تجربه بیماران دیگر
                        استفاده نمایند.
                    </p>
                </div>
                <div class="col-md-6" data-aos="fade-up" data-aos-delay="200">
                    <!-- <i class="bx bx-cube-alt"></i> -->
                    <img class="bx img-doctor" src="assets/img/svg/doctor.svg">
                    <h4>پزشکان</h4>
                    <p>
                        پزشکان با استفاده از امکانات و قابلیت‌های دکترمی می‌توانند نسخه الکترونیک صادر کنند، خلاصه
                        پرونده بیماران خود را رویت نمایند و هر آنچه برای مدیریت مطب به آن نیاز دارند را در اختیار داشته
                        باشند.
                    </p>
                </div>
            </div>
        </div>
    </div>

</div>